import React from 'react';
export function CatalogSkeleton() {
  return <div className="mt-8 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" aria-busy="true" aria-label="Cargando inventario" data-id="element-110" data-mp="37jqnxvxm4w1b">
      {Array.from({
      length: 6
    }).map((_, i) => <div key={i} className="animate-pulse overflow-hidden rounded-3xl bg-panel shadow-neon" data-id="element-111" data-mp="3jtv0zr8cuuo6" data-mpi={i}>
          <div className="aspect-[3/2] bg-raised" data-id="element-112" data-mp="3ev0hso6h743j" />
          <div className="space-y-3 p-6" data-id="element-113" data-mp="gcd5mj9rrg4n">
            <div className="h-3 w-24 rounded-full bg-raised" data-id="element-114" data-mp="gbbivhje5573" />
            <div className="h-6 w-3/4 rounded-full bg-raised" data-id="element-115" data-mp="bdidgqpwwf7v" />
            <div className="h-24 rounded-2xl bg-raised" data-id="element-116" data-mp="be1um57qmzku" />
            <div className="h-12 rounded-xl bg-raised" data-id="element-117" data-mp="6lrww30dsv80" />
          </div>
        </div>)}
    </div>;
}